
export const schemaMarkupData = {
    "fakturering-utan-foretag": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "BreadcrumbList",
            "@id": "https://www.invozio.com/fakturering-utan-foretag#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Hem",
                "item": "https://www.invozio.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Fakturering utan företag",
                "item": "https://www.invozio.com/fakturering-utan-foretag"
              }
            ]
          },
          {
            "@type": "Article",
            "@id": "https://www.invozio.com/fakturering-utan-foretag#article",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.invozio.com/fakturering-utan-foretag"
            },
            "headline": "Fakturering utan företag i Sverige 2025 – den ultimata guiden",
            "description": "Så fungerar fakturering utan företag i Sverige – komplett guide för frilansare, kreatörer och konsulter via egenanställning.",
            "image": {
              "@type": "ImageObject",
              "url": "https://www.invozio.com/images/fakturering-utan-foretag.jpg",
              "height": 800,
              "width": 1200,
              "caption": "fakturering utan företag i Sverige"
            },
            "author": {
              "@type": "Organization",
              "name": "Invozio",
              "url": "https://www.invozio.com"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Invozio",
              "url": "https://www.invozio.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/invozio-logo.png",
                "width": 600,
                "height": 60
              }
            },
            "datePublished": "2025-03-21",
            "dateModified": "2025-03-21",
            "keywords": [
              "fakturering utan företag",
              "egenanställning",
              "frilansa utan företag",
              "hur fakturerar man utan företag",
              "skicka faktura utan eget företag",
              "Invozio",
              "fakturera som student",
              "fakturera utan F-skatt"
            ],
            "articleSection": [
              "Fakturering utan företag i Sverige",
              "Vad är fakturering utan företag?",
              "Vem kan fakturera utan företag?",
              "Hur fungerar fakturering utan företag?",
              "Vad är egenanställning?",
              "Fördelar och nackdelar",
              "Branscher som använder det",
              "Skillnader mot anställning och F-skatt",
              "Kostnader, lön och deklaration",
              "ROT & RUT, a-kassa och pension",
              "Juridisk trygghet",
              "FAQ",
              "Framtiden för egenanställning",
              "Slutsats"
            ],
            "about": [
              {
                "@type": "Thing",
                "name": "Fakturering utan företag"
              },
              {
                "@type": "Thing",
                "name": "Egenanställning"
              },
              {
                "@type": "Thing",
                "name": "Frilans i Sverige"
              }
            ],
            "speakable": {
              "@type": "SpeakableSpecification",
              "xpath": [
                "/html/head/title",
                "/html/body//h1",
                "/html/body//p[1]"
              ]
            },
            "potentialAction": {
              "@type": "ReadAction",
              "target": [
                "https://www.invozio.com/fakturering-utan-foretag"
              ]
            }
          },
          {
            "@type": "FAQPage",
            "@id": "https://www.invozio.com/fakturering-utan-foretag#faq",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Kan jag fakturera utan företag som student?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja, det går utmärkt. Du betalar skatt som vanligt, men slipper starta företag."
                }
              },
              {
                "@type": "Question",
                "name": "Vad händer om kunden inte betalar fakturan?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Egenanställningsföretaget hjälper dig ofta med påminnelser och inkasso."
                }
              },
              {
                "@type": "Question",
                "name": "Hur mycket får jag ut efter skatt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Du får ut cirka 50–60% av fakturabeloppet efter avgifter, skatt och sociala avgifter."
                }
              },
              {
                "@type": "Question",
                "name": "Kan jag dra av för inköp?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Nej, det är egenanställningsföretaget som är juridisk person och gör avdragen."
                }
              },
              {
                "@type": "Question",
                "name": "Måste jag ha F-skatt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Nej. Det är just poängen – du fakturerar utan att själv ha F-skatt."
                }
              },
              {
                "@type": "Question",
                "name": "Får jag semesterersättning?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja! Den ingår i löneutbetalningen som ett tillägg."
                }
              }
            ]
          }
        ]
    },
    "home": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Invozio - Fakturera utan företag",
        "url": "https://www.invozio.com",
        "description": "Invozio är en snabbt växande plattform för frilansare och självständiga yrkesutövare. Vi möjliggör för individer att driva affärsverksamhet och skicka fakturor utan att behöva starta eget företag.",
        "image": [
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/header_laptop.webp",
                "width": 1200,
                "height": 800,
                "caption": "Invozio dashboard för fakturering utan företag"
            },
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/logo_large.png",
                "width": 600,
                "height": 200,
                "caption": "Invozio logotyp"
            },
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/invoicemobile.png",
                "width": 400,
                "height": 800,
                "caption": "Fakturera från mobilen med Invozio"
            }
        ],
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                }
            ]
        },
        "mainEntity": [
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Vilken skattesats gäller för egenanställda?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Som egenanställd via Invozio gäller standard skattesatser enligt svensk lagstiftning. Vi hjälper dig att säkerställa att rätt skattebelopp dras från din lön."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Får jag ett anställningsbevis från Invozio?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ja, när du är egenanställd hos Invozio får du ett anställningsbevis som bekräftar din anställning hos oss under de perioder du arbetar."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Kan jag göra avdrag för utgifter?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ja, som egenanställd har du möjlighet att dra av nödvändiga och skäliga utgifter relaterade till ditt arbete. Dessa avdrag hanteras genom Invozio."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Påverkar egenanställning min kredithistorik?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Nej, att vara egenanställd via Invozio påverkar inte din personliga kredithistorik eftersom du är anställd av oss och vi hanterar faktureringen åt dig."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Hur och när får jag min lön?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Din lön betalas ut så snart vi har mottagit betalning från din kund. Vi erbjuder snabba och säkra löneutbetalningar direkt till ditt bankkonto."
                        }
                    }
                ]
            },
            {
                "@type": "AggregateRating",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio",
                    "url": "https://www.invozio.com"
                },
                "ratingValue": "4.8",
                "reviewCount": "245",
                "bestRating": "5",
                "worstRating": "1"
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Erik Svensson"
                },
                "reviewBody": "Jag är supernöjd med Invozio! Processen är smidig och jag fick min lön snabbt utan problem.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Anna Lindberg"
                },
                "reviewBody": "Enkel och trygg tjänst! Jag kan fokusera på mitt arbete och låta Invozio sköta faktureringen.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            }
        ]
    },
    "om-invozio": {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Invozio",
        "url": "https://www.invozio.com",
        "logo": "https://www.invozio.com/logo.png",
        "description": "Invozio är en ledande leverantör för egenanställning som erbjuder trygghet och flexibilitet för egenanställda i olika branscher.",
        "sameAs": [
            "https://www.facebook.com/Invozio/",
            "https://www.instagram.com/invozio/"
        ],
        "contactPoint": {
            "@type": "ContactPoint",
            "email": "support@invozio.com",
            "contactType": "Kundtjänst",
            "availableLanguage": "sv"
        }
    },
    "faq": {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Vilken skattesats gäller för egenanställda?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Som egenanställd via Invozio gäller standard skattesatser enligt svensk lagstiftning. Vi hjälper dig att säkerställa att rätt skattebelopp dras från din lön."
                }
            },
            {
                "@type": "Question",
                "name": "Får jag ett anställningsbevis från Invozio?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ja, när du är egenanställd hos Invozio får du ett anställningsbevis som bekräftar din anställning hos oss under de perioder du arbetar."
                }
            },
             {
                "@type": "Question",
                "name": "Hur fungerar milersättning via Invozio?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Vi tillåter 25 kr per mil skattefritt i enlighet med Skatteverkets regler. All milersättning utöver 25 kr/mil är skattepliktig och behöver därför beskattas.Ni kan enkelt fylla i vår körjournal direkt i faktureringsverktyget. Den hjälper er att räkna ut hur många mil ni har kört och säkerställer att all information vi behöver finns med."
                }
            },
            {
                "@type": "Question",
                "name": "Kan jag göra avdrag för utgifter?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ja, som egenanställd har du möjlighet att dra av nödvändiga och skäliga utgifter relaterade till ditt arbete. Dessa avdrag hanteras genom Invozio."
                }
            },
            {
                "@type": "Question",
                "name": "Påverkar egenanställning min kredithistorik?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nej, att vara egenanställd via Invozio påverkar inte din personliga kredithistorik eftersom du är anställd av oss och vi hanterar faktureringen åt dig."
                }
            },
            {
                "@type": "Question",
                "name": "Hur och när får jag min lön?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Din lön betalas ut så snart vi har mottagit betalning från din kund. Vi erbjuder snabba och säkra löneutbetalningar direkt till ditt bankkonto."
                }
            }
        ]
    },
    "egenanstallning": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Egenanställning - Fakturera utan företag",
        "url": "https://www.invozio.com/egenanstallning",
        "description": "Egenanställning innebär att du är anställd i ett egenanställningsföretag under den tid du utför ett uppdrag hos en kund. Efter avslutat uppdrag, eller ...",
        "image": {
            "@type": "ImageObject",
            "url": "https://www.invozio.com/assets/png/freelance-life-page-laptop.png",
            "width": 1200,
            "height": 800,
            "caption": "Egenanställning och fakturering utan företag"
        },
        "keywords": ["egenanställning", "fakturera utan företag", "frilans", "konsult", "Invozio"],
        "datePublished": "2025-02-27",
        "dateModified": "2025-02-27",
        "inLanguage": "sv",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Egenanställning",
                    "item": "https://www.invozio.com/egenanstallning"
                }
            ]
        },
        "mainEntity": {
            "@type": "Service",
            "name": "Egenanställningstjänst",
            "provider": {
                "@type": "Organization",
                "name": "Invozio"
            },
            "serviceType": "Egenanställning",
            "areaServed": {
                "@type": "Country",
                "name": "Sverige"
            },
            "description": "Invozio erbjuder en tjänst där individer kan fakturera utan att starta eget företag genom att vara anställda hos oss under uppdragets gång.",
            "offers": {
                "@type": "Offer",
                "priceCurrency": "SEK",
                "price": "5%",
                "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "unitText": "provision"
                },
                "availability": "https://schema.org/InStock",
                "url": "https://www.invozio.com/egenanstallning"
            }
        }
    },
    "foretag": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Företag - Egenanställningstjänster för företag",
        "url": "https://www.invozio.com/foretag",
        "description": "Invozio erbjuder företag en smidig och flexibel lösning för att hantera löneutbetalningar till konsulter och tillfällig personal. Effektiv fakturering utan egen administration.",
        "image": {
            "@type": "ImageObject",
            "url": "https://www.invozio.com/assets/png/businessesWork.png",
            "width": 1000,
            "height": 700,
            "caption": "Lönehantering för företag med Invozio"
        },
        "keywords": ["egenanställning företag", "lönehantering företag", "fakturering utan företag", "konsultavtal", "betala frilansare"],
        "datePublished": "2025-02-27",
        "dateModified": "2025-02-27",
        "inLanguage": "sv",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Customer Service",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Företag",
                    "item": "https://www.invozio.com/foretag"
                }
            ]
        },
        "mainEntity": {
            "@type": "Service",
            "name": "Lönehantering för företag",
            "provider": {
                "@type": "Organization",
                "name": "Invozio"
            },
            "serviceType": "Egenanställningstjänst",
            "areaServed": {
                "@type": "Country",
                "name": "Sverige"
            },
            "description": "Invozio hjälper företag att betala konsulter, frilansare och tillfälliga anställda utan att behöva hantera löneadministration.",
            "offers": {
                "@type": "Offer",
                "priceCurrency": "SEK",
                "price": "Från 5%",
                "availability": "https://schema.org/InStock",
                "url": "https://www.invozio.com/foretag"
            }
        }
    },
    "fakturera-utan-foretag-eller-bolag": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Fakturera utan företag eller bolag - Invozio",
        "url": "https://www.invozio.com/fakturera-utan-foretag-eller-bolag",
        "description": "Invozio erbjuder en tjänst där du som privatperson kan fakturera för dina tjänster eller uppdrag utan att behöva starta eget företag. Vi hanterar all administration och ser till att du får din lön snabbt och enkelt.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Fakturera utan företag eller bolag",
                    "item": "https://www.invozio.com/fakturera-utan-foretag-eller-bolag"
                }
            ]
        },
        "mainEntity": [
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Hur fungerar det att fakturera utan företag?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Genom Invozio kan du som privatperson fakturera dina kunder utan att ha ett eget företag. Vi sköter all administration, inklusive skatter och avgifter, och du får din lön utbetald direkt till ditt konto."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Vilka avgifter tar Invozio för sina tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Invozio erbjuder en transparent prissättning med en fast avgift på 5% av fakturabeloppet. Det tillkommer inga dolda avgifter."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Behöver jag ha F-skatt för att använda Invozios tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Nej, du behöver inte ha F-skatt. Invozio agerar som din arbetsgivare och hanterar alla skatter och avgifter åt dig."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Hur snabbt får jag min lön efter att kunden har betalat fakturan?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Så snart vi har mottagit betalningen från din kund överför vi din lön till ditt bankkonto inom 1-2 arbetsdagar."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Kan jag fakturera för både varor och tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ja, genom Invozio kan du fakturera för både varor och tjänster utan att behöva starta eget företag."
                        }
                    }
                ]
            },
            {
                "@type": "AggregateRating",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio",
                    "url": "https://www.invozio.com"
                },
                "ratingValue": "4.8",
                "reviewCount": "245",
                "bestRating": "5",
                "worstRating": "1"
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Erik Svensson"
                },
                "reviewBody": "Jag är supernöjd med Invozio! Processen är smidig och jag fick min lön snabbt utan problem.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Anna Lindberg"
                },
                "reviewBody": "Enkel och trygg tjänst! Jag kan fokusera på mitt arbete och låta Invozio sköta faktureringen.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            }
        ]
    },
    "fakturera-som-konsult-lon": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Fakturera som konsult - Lön och tips | Invozio",
        "url": "https://www.invozio.com/fakturera-som-konsult-lon",
        "description": "Lär dig hur du som konsult kan fakturera utan eget företag och få ut din lön snabbt och enkelt med Invozio. Vi hanterar all administration åt dig.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Fakturera som konsult - Lön",
                    "item": "https://www.invozio.com/fakturera-som-konsult-lon"
                }
            ]
        },
        "mainEntity": [
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Hur kan jag som konsult fakturera utan eget företag?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Genom Invozio kan du som konsult fakturera dina kunder utan att ha ett eget företag. Vi sköter all administration, inklusive skatter och avgifter, och du får din lön utbetald direkt till ditt konto."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Vilka avgifter tar Invozio för sina tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Invozio erbjuder en transparent prissättning med en fast avgift på 5% av fakturabeloppet. Det tillkommer inga dolda avgifter."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Behöver jag ha F-skatt för att använda Invozios tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Nej, du behöver inte ha F-skatt. Invozio agerar som din arbetsgivare och hanterar alla skatter och avgifter åt dig."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Hur snabbt får jag min lön efter att kunden har betalat fakturan?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Så snart vi har mottagit betalningen från din kund överför vi din lön till ditt bankkonto inom 1-2 arbetsdagar."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Kan jag fakturera för både varor och tjänster?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ja, genom Invozio kan du fakturera för både varor och tjänster utan att behöva starta eget företag."
                        }
                    }
                ]
            },
            {
                "@type": "AggregateRating",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio",
                    "url": "https://www.invozio.com"
                },
                "ratingValue": "4.8",
                "reviewCount": "245",
                "bestRating": "5",
                "worstRating": "1"
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Erik Svensson"
                },
                "reviewBody": "Jag är supernöjd med Invozio! Processen är smidig och jag fick min lön snabbt utan problem.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            },
            {
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio"
                },
                "author": {
                    "@type": "Person",
                    "name": "Anna Lindberg"
                },
                "reviewBody": "Enkel och trygg tjänst! Jag kan fokusera på mitt arbete och låta Invozio sköta faktureringen.",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1"
                }
            }
        ]
    },
    "frilans-frilansarbete": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Frilans & Frilansarbete - Fakturera utan företag | Invozio",
        "url": "https://www.invozio.com/frilans-frilansarbete",
        "description": "Upptäck hur du kan arbeta som frilansare och fakturera dina kunder utan eget företag med Invozio. Enkelt, tryggt och flexibelt!",
        "image": [
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/freelance-life-page-man.webp",
                "width": 800,
                "height": 1000,
                "caption": "Frilansare som arbetar flexibelt"
            },
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/invozio-help-as-a-freelancer.webp",
                "width": 1000,
                "height": 600,
                "caption": "Invozio hjälper frilansare"
            }
        ],
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Frilans & Frilansarbete",
                    "item": "https://www.invozio.com/frilans-frilansarbete"
                }
            ]
        },
        "mainEntity": [
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Hur fungerar det att arbeta som frilansare med Invozio?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Som frilansare kan du enkelt fakturera dina kunder utan att ha ett eget företag. Invozio hanterar allt från administration och skatter till löneutbetalning."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Vad kostar det att använda Invozio som frilansare?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Invozio tar en fast avgift på 5% av fakturabeloppet. Det finns inga dolda kostnader eller startavgifter."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Behöver jag ha F-skatt för att arbeta som frilansare via Invozio?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Nej, du behöver inte ha F-skatt. Invozio agerar som din arbetsgivare och betalar in alla skatter och avgifter åt dig."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Hur snabbt får jag betalt efter att jag fakturerat en kund?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Din lön betalas ut så snart din kund har betalat fakturan, vanligtvis inom 1-2 arbetsdagar."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Kan jag använda Invozio för frilansuppdrag utomlands?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ja, du kan fakturera både svenska och internationella kunder genom Invozio, men moms och skatter kan variera beroende på land."
                        }
                    }
                ]
            },
            {
                "@type": "AggregateRating",
                "itemReviewed": {
                    "@type": "Organization",
                    "name": "Invozio",
                    "url": "https://www.invozio.com"
                },
                "ratingValue": "4.8",
                "reviewCount": "245",
                "bestRating": "5",
                "worstRating": "1"
            }
        ]
    },
    "fakturera-som-privatperson_egenanstalld": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Fakturera som privatperson & Egenanställd | Invozio",
        "url": "https://www.invozio.com/fakturera-som-privatperson_egenanstalld",
        "description": "Lär dig hur du som privatperson kan fakturera för dina tjänster utan att ha ett eget företag genom att bli egenanställd hos Invozio. Snabbt, tryggt och enkelt!",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/logo.png"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Fakturera som privatperson & Egenanställd",
                    "item": "https://www.invozio.com/fakturera-som-privatperson_egenanstalld"
                }
            ]
        },
        "mainEntity": [
            {
                "@type": "Article",
                "headline": "Fakturera som privatperson utan företag",
                "articleSection": [
                    "Vad innebär det att fakturera som privatperson? Att fakturera som privatperson innebär att du kan ta betalt för dina tjänster utan att ha ett eget företag. Genom Invozio hanteras skatter och avgifter åt dig, vilket gör processen enkel och smidig.",
                    "Fördelar med att vara egenanställd: Som egenanställd slipper du starta ett eget företag, hantera bokföring eller deklarationer. Invozio tar hand om all administration och du får lön efter skatt.",
                    "Steg för att fakturera utan företag: 1. Registrera dig hos Invozio. 2. Skapa en faktura till din kund. 3. När kunden betalar hanterar Invozio skatter och avgifter och du får din lön utbetald."
                ]
            },
            {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Kan jag fakturera utan företag som privatperson?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja! Med Invozio kan du fakturera dina kunder utan att ha en egen firma eller bolag. Vi sköter all administration och ser till att du får lön utbetald efter skatt."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vilka avgifter tar Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Invozio tar en fast avgift på 5% av fakturabeloppet. Det finns inga dolda avgifter eller abonnemangskostnader."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Behöver jag registrera F-skatt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, du behöver inte ha F-skatt. Invozio fungerar som din arbetsgivare och hanterar alla skatter och avgifter åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur snabbt får jag betalt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Efter att din kund har betalat fakturan överför vi din lön inom 1–2 arbetsdagar."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Är det tillåtet att fakturera som privatperson?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja, det är helt lagligt – men bara under vissa förutsättningar. Du får fakturera som privatperson så länge det handlar om enstaka eller tillfälliga uppdrag. Om jobben börjar komma in regelbundet behöver du registrera en egen firma och skaffa F-skatt. För de som mest vill testa frilanslivet eller ta mindre uppdrag då och då är tjänster som Invozio ett smidigt sätt att sköta allt utan att starta företag."
                    }
                },
                  {
                    "@type": "Question",
                    "name": "Måste jag ha företag eller F-skatt för att fakturera?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, det behöver du inte. Invozio fungerar som din arbetsgivare och ser till att all administration sköts enligt regelboken. Du slipper bokföring, moms och F-skatt – och kan ändå skicka fakturor på ett helt korrekt sätt. Det gör att många snabbt kommer igång utan att binda upp sig till ett företag."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur går det till när man fakturerar via Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Det är egentligen väldigt enkelt. Du skapar ett konto, fyller i vem kunden är och vad du gjort, och sedan sköter Invozio resten. Fakturan skickas automatiskt, och när kunden har betalat får du lönen insatt på kontot. Alla skatter och avgifter är redan dragna, så du slipper tänka på administrativt krångel."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur funkar skatter och avgifter när jag fakturerar som privatperson?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Skatten sköts åt dig. Du behöver inte räkna ut någon moms, inte hålla koll på arbetsgivaravgifter och inte lämna in någon redovisning själv. Invozio gör hela jobbet i bakgrunden och du får din lön utbetald precis som om du vore anställd. Det gör att du kan ta uppdrag utan att riskera att göra fel mot Skatteverket"
                    }
                },
                   {
                    "@type": "Question",
                    "name": "Vad kostar det att använda Invozio för att fakturera?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Avgiften ligger på 1,4 %, vilket är lägre än många liknande tjänster. Det är också den summa som täcker hela administrationen – fakturor, skatter, sociala avgifter och allt som rör utbetalningen av din lön. Många upplever att det är ett litet pris för att slippa allt pappersarbete."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad händer om kunden inte betalar i tid?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Du behöver inte jaga någon. Invozio hanterar påminnelser och den administrativa delen kring sena betalningar. Det ger en extra trygghet, särskilt för frilansare och privatpersoner som inte vill hamna i situationer där de måste driva in betalningar själva."
                    }
                }
            ]
        }
    ]
    },
    "frilans-konsult-lon-fakturera-utan-foretag": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Frilans Konsult Lön – Fakturera utan företag | Invozio",
        "url": "https://www.invozio.com/frilans-konsult-lon-fakturera-utan-foretag",
        "description": "Upptäck hur du som frilansare eller konsult kan fakturera dina kunder utan att ha ett eget företag. Invozio gör processen smidig och trygg.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Frilans Konsult Lön – Fakturera utan företag",
                    "item": "https://www.invozio.com/frilans-konsult-lon-fakturera-utan-foretag"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Frilans Konsult Lön – Så fungerar det att fakturera utan företag",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Varför välja fakturering utan företag?",
                    "text": "Att fakturera utan företag ger dig friheten att arbeta som frilansare eller konsult utan att hantera bokföring, skatter och administration själv. Invozio tar hand om hela processen."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Så här fungerar det med Invozio",
                    "text": "1. Skapa ett konto hos Invozio. 2. Skapa en faktura och skicka till din kund. 3. När kunden betalar hanterar vi skatter och avgifter och betalar ut din lön."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Fördelar med Invozio",
                    "text": "✔ Ingen F-skatt krävs ✔ Enkel fakturering ✔ Snabb löneutbetalning ✔ 100% trygghet"
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Kan jag fakturera utan företag som konsult?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja! Genom Invozio kan du fakturera dina kunder utan att ha en egen firma eller bolag. Vi sköter all administration och betalar ut din lön efter skatt."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad kostar det att använda Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Invozio tar en fast avgift på 5% av fakturabeloppet. Det finns inga dolda kostnader eller abonnemang."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Måste jag registrera F-skatt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, du behöver inte ha F-skatt. Invozio fungerar som din arbetsgivare och hanterar alla skatter och avgifter åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur snabbt får jag betalt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "När kunden har betalat fakturan överför vi din lön till ditt bankkonto inom 1-2 arbetsdagar."
                    }
                }
            ]
        }
    },
    "hur-mycket-ska-jag-fakturera-som-frilansare": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Hur mycket ska jag fakturera som frilansare? | Invozio",
        "url": "https://www.invozio.com/hur-mycket-ska-jag-fakturera-som-frilansare",
        "description": "Lär dig hur du som frilansare kan räkna ut rätt faktureringsbelopp för att täcka skatter, avgifter och din önskade lön. Invozio hjälper dig att fakturera utan företag.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Hur mycket ska jag fakturera som frilansare?",
                    "item": "https://www.invozio.com/hur-mycket-ska-jag-fakturera-som-frilansare"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Hur mycket ska jag fakturera som frilansare?",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Vad påverkar din fakturering?",
                    "text": "Som frilansare behöver du ta hänsyn till skatter, arbetsgivaravgifter och dina fasta kostnader när du bestämmer ditt faktureringsbelopp."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Räkna ut din frilanslön",
                    "text": "En tumregel är att fakturera cirka 2-3 gånger den lön du vill ha efter skatt för att täcka alla avgifter och skatter."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Använd en faktureringskalkylator",
                    "text": "Med Invozios kalkylator kan du enkelt räkna ut hur mycket du ska fakturera för att få din önskade nettolön."
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Hur räknar jag ut mitt faktureringsbelopp?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Du bör fakturera minst 2-3 gånger den lön du vill ha efter skatt för att täcka skatter och arbetsgivaravgifter. Använd gärna Invozios faktureringskalkylator för att få en exakt siffra."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vilka avgifter tillkommer vid fakturering?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "När du fakturerar genom Invozio tillkommer arbetsgivaravgifter och skatter. Invozio tar en fast avgift på 5% av fakturabeloppet."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur mycket skatt betalar jag som frilansare?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Skattesatsen beror på din kommun och inkomst, men som en riktlinje ligger den på cirka 30-50%. Invozio hanterar skatteinbetalningar åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Kan jag använda Invozio för att fakturera utan företag?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja! Invozio gör det möjligt att fakturera som privatperson utan att ha en egen firma eller bolag. Vi sköter all administration och ser till att du får din lön utbetald."
                    }
                }
            ]
        }
    },
    "att-jobba-som-frilansare-och-fakturera-utan-fskatt": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Att jobba som frilansare och fakturera utan F-skatt | Invozio",
        "url": "https://www.invozio.com/att-jobba-som-frilansare-och-fakturera-utan-fskatt",
        "description": "Lär dig hur du kan arbeta som frilansare och fakturera kunder utan att behöva ha F-skatt. Invozio gör processen smidig och trygg genom egenanställning.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Att jobba som frilansare och fakturera utan F-skatt",
                    "item": "https://www.invozio.com/att-jobba-som-frilansare-och-fakturera-utan-fskatt"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Att jobba som frilansare och fakturera utan F-skatt",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Kan man fakturera utan F-skatt?",
                    "text": "Ja, genom att använda en egenanställningstjänst som Invozio kan du fakturera utan att ha F-skatt. Vi sköter all administration och betalar ut din lön efter skatt."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Så fungerar det att fakturera utan F-skatt",
                    "text": "1. Registrera dig hos Invozio. 2. Skapa en faktura och skicka till din kund. 3. När kunden betalar hanterar vi skatter och avgifter och betalar ut din lön."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Fördelar med att fakturera utan F-skatt",
                    "text": "✔ Ingen F-skatt krävs ✔ Enkel och trygg fakturering ✔ Snabb löneutbetalning ✔ Inga administrativa krav"
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Måste jag ha F-skatt för att frilansa?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej! Med Invozio kan du fakturera utan att ha F-skatt. Vi fungerar som din arbetsgivare och hanterar alla skatter och avgifter åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur mycket skatt betalar jag utan F-skatt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Skatten beror på din kommun och inkomst, men den ligger vanligtvis på 30-50%. Invozio ser till att rätt skatter och avgifter betalas in."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad kostar det att fakturera utan F-skatt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Invozio tar en fast avgift på 5% av fakturabeloppet. Det finns inga dolda kostnader eller abonnemang."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur snabbt får jag min lön?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "När kunden har betalat fakturan överför vi din lön till ditt bankkonto inom 1-2 arbetsdagar."
                    }
                }
            ]
        }
    },
    "fran-faktura-till-forhandling": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Från faktura till förhandling | Invozio",
        "url": "https://www.invozio.com/fran-faktura-till-forhandling",
        "description": "Lär dig hur du som frilansare kan hantera hela processen från att skicka en faktura till att förhandla bättre villkor med kunder. Invozio hjälper dig med smidig fakturering utan företag.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Från faktura till förhandling",
                    "item": "https://www.invozio.com/fran-faktura-till-forhandling"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Från faktura till förhandling – Så hanterar du hela processen",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Steg 1: Skapa och skicka fakturan",
                    "text": "Att skapa en tydlig och professionell faktura är det första steget i att få betalt som frilansare. Använd en fakturamall och specificera arbetsbeskrivning, pris och betalningsvillkor."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Steg 2: Följ upp din faktura",
                    "text": "Om kunden inte betalar i tid, skicka en vänlig påminnelse och var tydlig med betalningsvillkoren."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Steg 3: Förhandla om bättre villkor",
                    "text": "Förhandling är en viktig del av frilanslivet. Var beredd att diskutera din prissättning och ha argument för varför du är värd din ersättning."
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Hur skapar jag en korrekt faktura?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "En faktura bör innehålla ditt namn, kundens uppgifter, en beskrivning av tjänsten, pris, betalningsvillkor och bankuppgifter för betalning."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad gör jag om en kund inte betalar?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Skicka en betalningspåminnelse och var tydlig med förfallodatumet. Om betalningen fortfarande uteblir kan du ta hjälp av ett inkassobolag."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur kan jag förhandla om bättre villkor?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Presentera din erfarenhet, värdet av ditt arbete och jämför med marknadspriser. Var beredd att kompromissa, men stå fast vid din miniminivå."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Kan jag använda Invozio för att fakturera utan företag?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja! Med Invozio kan du fakturera som privatperson utan att starta eget företag. Vi hanterar skatter och administration åt dig."
                    }
                }
            ]
        }
    },
    "starta-eget-foretag-eller-fakturera-som-privatperson": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Starta eget företag eller fakturera som privatperson | Invozio",
        "url": "https://www.invozio.com/starta-eget-foretag-eller-fakturera-som-privatperson",
        "description": "Ska du starta eget företag eller fakturera som privatperson? Lär dig skillnaderna, fördelarna och nackdelarna med båda alternativen och vad som passar dig bäst.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": "sv"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Starta eget företag eller fakturera som privatperson",
                    "item": "https://www.invozio.com/starta-eget-foretag-eller-fakturera-som-privatperson"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Starta eget företag eller fakturera som privatperson – Vad är bäst för dig?",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Skillnader mellan att starta företag och fakturera som privatperson",
                    "text": "Att starta eget företag innebär att du måste registrera en verksamhet, hantera bokföring och betala egenavgifter. Att fakturera som privatperson genom en egenanställningstjänst som Invozio innebär att du slipper administrativt arbete och kan få lön direkt."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Fördelar med att starta eget företag",
                    "text": "✔ Full kontroll över din verksamhet ✔ Möjlighet att göra avdrag ✔ Möjlighet att bygga ett varumärke"
                },
                {
                    "@type": "WebPageElement",
                    "name": "Fördelar med att fakturera som privatperson",
                    "text": "✔ Ingen bokföring ✔ Ingen registrering hos Bolagsverket ✔ Snabba löneutbetalningar ✔ All administration hanteras åt dig"
                },
                {
                    "@type": "WebPageElement",
                    "name": "Vilket alternativ ska du välja?",
                    "text": "Om du planerar att driva en långsiktig verksamhet med många kunder kan ett eget företag vara ett bra val. Om du vill testa frilanslivet eller undvika administration kan fakturering som privatperson vara det enklaste alternativet."
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Måste jag starta eget företag för att fakturera?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, du kan fakturera som privatperson genom en egenanställningstjänst som Invozio. Vi sköter alla skatter och avgifter åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad är skillnaden mellan F-skatt och egenanställning?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Med F-skatt driver du ett eget företag och ansvarar själv för skatter och avgifter. Med egenanställning är du anställd av Invozio, och vi sköter administrationen åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Kan jag dra av kostnader om jag fakturerar som privatperson?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, eftersom du inte har ett företag kan du inte göra avdrag för inköp. Däremot kan du inkludera vissa kostnader i din faktura."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur snabbt får jag betalt om jag fakturerar via Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "När kunden har betalat fakturan överför vi din lön till ditt bankkonto inom 1-2 arbetsdagar."
                    }
                }
            ]
        }
    },
    "kontakta-oss": {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Kontakta oss | Invozio",
        "url": "https://www.invozio.com/kontakta-oss",
        "description": "Kontakta Invozio för frågor om fakturering, egenanställning eller support. Vi finns här för att hjälpa dig via telefon, e-post och sociala medier.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "contactType": "Kundtjänst",
                    "telephone": "010-264 88 10",
                    "email": "support@invozio.com",
                    "availableLanguage": ["sv", "en"],
                    "areaServed": "SE"
                },
                {
                    "@type": "ContactPoint",
                    "contactType": "Fakturafrågor",
                    "telephone": "010-264 88 11",
                    "email": "faktura@invozio.com",
                    "availableLanguage": ["sv", "en"],
                    "areaServed": "SE"
                }
            ],
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Kontakta oss",
                    "item": "https://www.invozio.com/kontakta-oss"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Kontakta oss – Vi hjälper dig!",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Hur kan vi hjälpa dig?",
                    "text": "Vår kundtjänst är redo att svara på dina frågor om fakturering, egenanställning och andra tjänster. Kontakta oss via telefon, e-post eller sociala medier."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Våra kontaktuppgifter",
                    "text": "Telefon: 010-264 88 10\nE-post: support@invozio.com\nAdress: Exempelgatan 10, 123 45 Stockholm"
                },
                {
                    "@type": "WebPageElement",
                    "name": "Vanliga frågor",
                    "text": "Innan du kontaktar oss, se vår FAQ-sektion för svar på de vanligaste frågorna om fakturering och egenanställning."
                }
            ]
        }
    },
    "funktion": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Hur fungerar Invozio? | Invozio",
        "url": "https://www.invozio.com/funktion",
        "description": "Lär dig hur Invozio fungerar och hur du kan fakturera utan företag som egenanställd. En enkel, trygg och smidig lösning för frilansare och konsulter.",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": ["sv", "en"],
                "areaServed": "SE"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Hur fungerar Invozio?",
                    "item": "https://www.invozio.com/funktion"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Hur fungerar Invozio? Så enkelt är det!",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "1. Registrera dig hos Invozio",
                    "text": "För att börja fakturera utan företag behöver du skapa ett konto hos Invozio. Det tar bara några minuter och är helt kostnadsfritt."
                },
                {
                    "@type": "WebPageElement",
                    "name": "2. Skapa och skicka din faktura",
                    "text": "När du har utfört ett arbete för en kund skapar du en faktura direkt i vårt system. Ange kundens uppgifter, arbetsbeskrivning och fakturabelopp."
                },
                {
                    "@type": "WebPageElement",
                    "name": "3. Kunden betalar fakturan",
                    "text": "Din kund betalar fakturan till Invozio, och vi hanterar alla skatter och avgifter åt dig."
                },
                {
                    "@type": "WebPageElement",
                    "name": "4. Du får din lön utbetald",
                    "text": "Så snart fakturan är betald överför vi din lön till ditt bankkonto efter avdrag för skatter och avgifter."
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Vad är egenanställning?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Egenanställning innebär att du kan fakturera för ditt arbete utan att ha ett eget företag. Invozio fungerar som din arbetsgivare och hanterar administration och skatter åt dig."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur snabbt får jag min lön?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "När kunden har betalat fakturan får du din lön utbetald inom 1-2 arbetsdagar."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vilka avgifter tar Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Invozio tar en fast avgift på 5% av fakturabeloppet. Det finns inga dolda avgifter eller abonnemang."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Kan jag fakturera utan F-skatt?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja, du behöver inte ha F-skatt för att fakturera genom Invozio. Vi hanterar alla skatter och avgifter åt dig."
                    }
                }
            ]
        }
    },
    "ambassador": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Bli en Invozio Ambassadör | Invozio",
        "url": "https://www.invozio.com/ambassador",
        "description": "Bli en Invozio-ambassadör och tjäna pengar genom att rekommendera vår tjänst till andra. Läs mer om hur du kan gå med och få provision på varje ny kund.",
        "image": [
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/ambassdor-brand-image.webp",
                "width": 1200,
                "height": 800,
                "caption": "Bli Invozio ambassadör och tjäna pengar"
            },
            {
                "@type": "ImageObject",
                "url": "https://www.invozio.com/assets/png/brand-ambassdor-talk-img.webp",
                "width": 800,
                "height": 600,
                "caption": "Ambassadörsprogram för att sprida Invozio"
            }
        ],
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": ["sv", "en"],
                "areaServed": "SE"
            }
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Ambassadör",
                    "item": "https://www.invozio.com/ambassador"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Bli en Invozio Ambassadör och tjäna pengar",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Vad är Invozios Ambassadörsprogram?",
                    "text": "Invozios ambassadörsprogram låter dig tjäna pengar genom att rekommendera vår tjänst till andra. För varje ny kund du hänvisar får du en provision."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Hur fungerar det?",
                    "text": "1. Registrera dig som ambassadör hos Invozio.\n2. Dela din unika länk med vänner, kollegor och nätverk.\n3. Få betalt när någon registrerar sig och börjar fakturera via Invozio."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Varför bli en Invozio Ambassadör?",
                    "text": "✔ Tjäna extra pengar enkelt\n✔ Hjälp andra att komma igång med frilansande\n✔ Inga förkunskaper krävs\n✔ Transparent provision utan dolda avgifter"
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Hur mycket kan jag tjäna som ambassadör?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Du får en provision baserat på antalet personer du hänvisar och hur mycket de fakturerar. Kontakta oss för exakta provisioner."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur får jag min provision utbetald?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Provisionen betalas ut direkt till ditt bankkonto en gång i månaden."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Finns det några krav för att bli ambassadör?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, vem som helst kan ansöka om att bli en Invozio Ambassadör. Det enda du behöver göra är att dela din unika länk och sprida ordet om vår tjänst."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur registrerar jag mig som ambassadör?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Du kan registrera dig via vår hemsida på sidan för Ambassadörsprogrammet och få din unika hänvisningslänk direkt efter godkännande."
                    }
                }
            ]
        }
    },
    "nyheter": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Nyheter - Invozio",
        "url": "https://www.invozio.com/news",
        "description": "Håll dig uppdaterad med de senaste nyheterna från Invozio. Läs om nya funktioner, branschuppdateringar och tips för frilansare och konsulter.",
        "keywords": ["nyheter", "invozio news", "frilans nyheter", "egenanställning", "uppdateringar", "branschnyheter"],
        "datePublished": "2025-08-18",
        "dateModified": "2025-08-18",
        "inLanguage": "sv",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": ["sv", "en"],
                "areaServed": "SE"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Nyheter",
                    "item": "https://www.invozio.com/news"
                }
            ]
        },
        "mainEntity": {
            "@type": "ItemList",
            "name": "Invozio Nyheter",
            "description": "De senaste nyheterna och uppdateringarna från Invozio",
            "itemListElement": [
                {
                    "@type": "Article",
                    "position": 1,
                    "headline": "Nya funktioner i Invozio 2025",
                    "description": "Upptäck de senaste förbättringarna och funktionerna vi har lanserat för att göra fakturering ännu enklare.",
                    "author": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "datePublished": "2025-08-18"
                },
                {
                    "@type": "Article",
                    "position": 2,
                    "headline": "Skatteregler för frilansare 2025",
                    "description": "Viktiga uppdateringar om skatteregler som påverkar frilansare och konsulter i Sverige.",
                    "author": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "datePublished": "2025-08-15"
                },
                {
                    "@type": "Article",
                    "position": 3,
                    "headline": "Tips för framgångsrik fakturering",
                    "description": "Expertråd och bästa praxis för att optimera din faktureringsprocess och få betalt snabbare.",
                    "author": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Invozio"
                    },
                    "datePublished": "2025-08-10"
                }
            ]
        },
        "potentialAction": {
            "@type": "ReadAction",
            "target": [
                "https://www.invozio.com/news"
            ]
        }
    },
    "bokforing": {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Bokföring och administration - Invozio",
        "url": "https://www.invozio.com/book-keeping",
        "description": "Lär dig om bokföring och administration för frilansare och konsulter. Invozio hanterar all bokföring åt dig när du fakturerar utan företag.",
        "image": {
            "@type": "ImageObject",
            "url": "https://www.invozio.com/assets/png/bookkeeping-hero-image.webp",
            "width": 1200,
            "height": 700,
            "caption": "Bokföring och administration för frilansare"
        },
        "keywords": ["bokföring", "administration", "frilans bokföring", "egenanställning", "redovisning", "skattehantering"],
        "datePublished": "2025-08-18",
        "dateModified": "2025-08-18",
        "inLanguage": "sv",
        "publisher": {
            "@type": "Organization",
            "name": "Invozio",
            "url": "https://www.invozio.com",
            "logo": "https://www.invozio.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Kundtjänst",
                "telephone": "010-264 88 10",
                "email": "support@invozio.com",
                "availableLanguage": ["sv", "en"],
                "areaServed": "SE"
            },
            "sameAs": [
                "https://www.facebook.com/Invozio/",
                "https://www.instagram.com/invozio/"
            ]
        },
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Hem",
                    "item": "https://www.invozio.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Bokföring",
                    "item": "https://www.invozio.com/book-keeping"
                }
            ]
        },
        "articleBody": {
            "@type": "Article",
            "headline": "Bokföring för frilansare - Så slipper du krånglet",
            "articleSection": [
                {
                    "@type": "WebPageElement",
                    "name": "Vad innebär bokföring för frilansare?",
                    "text": "Bokföring innebär att systematiskt dokumentera alla intäkter och utgifter i din verksamhet. För frilansare kan detta vara komplext, men med Invozio slipper du hantera bokföring själv."
                },
                {
                    "@type": "WebPageElement",
                    "name": "Fördelar med att låta Invozio sköta bokföringen",
                    "text": "✔ Ingen egen bokföring krävs ✔ Automatisk skattehantering ✔ Professionell redovisning ✔ Mer tid för ditt arbete"
                },
                {
                    "@type": "WebPageElement",
                    "name": "Vad ingår i Invozios tjänst?",
                    "text": "Vi hanterar all bokföring, skattebetalningar, löneadministration och rapportering åt dig. Du fokuserar på ditt arbete medan vi tar hand om administrationen."
                }
            ]
        },
        "mainEntity": {
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Måste jag sköta egen bokföring som frilansare?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, när du fakturerar genom Invozio sköter vi all bokföring, skattehantering och administration åt dig. Du behöver inte hantera några ekonomiska rapporter själv."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Vad händer med mina skatter och avgifter?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Invozio betalar in alla skatter och arbetsgivaravgifter automatiskt. Du får en lönespecifikation som visar alla avdrag och din nettolön."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Får jag tillgång till bokföringsunderlag?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Ja, du kan när som helst få tillgång till dina lönespecifikationer och andra dokument via ditt konto hos Invozio."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Behöver jag ha kunskap om bokföring?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nej, du behöver ingen kunskap om bokföring. Invozio hanterar all ekonomisk administration så att du kan fokusera på ditt arbete."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Hur fungerar deklarationen när jag använder Invozio?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Du deklarerar som vanlig anställd eftersom du är anställd hos Invozio. Du får ett årsintyg som du använder i din deklaration, precis som andra anställda."
                    }
                }
            ]
        },
        "potentialAction": {
            "@type": "ReadAction",
            "target": [
                "https://www.invozio.com/book-keeping"
            ]
        }
    }
};
